export interface MerchantConnectStatus {
  connect_api_version?: string | null;
  connect_account_type?: string | null;
  charges_enabled?: boolean | null;
}

/** Match the merchant webhook's strict stored version/type pairs. */
export function merchantConnectState(config?: MerchantConnectStatus | null) {
  const connected =
    (config?.connect_api_version === "v1" && config.connect_account_type === "express") ||
    (config?.connect_api_version === "v2" && config.connect_account_type === "full");
  const chargesEnabled = connected && config?.charges_enabled === true;
  const connectState: "not_connected" | "pending" | "active" =
    !connected ? "not_connected" : chargesEnabled ? "active" : "pending";
  return { connected, chargesEnabled, connectState };
}